import {
  Grid,
  IconButton,
  TextField,
  LinearProgress,
  Card,
  CardContent,
  Tooltip,
} from "@mui/material";
import Box from "@mui/material/Box";
import ResponsiveDataGrid from "../../../../../components/MobileList/ResponsiveDataGrid";
import { BiInfoCircle } from "react-icons/bi";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MdOutlineClear } from "react-icons/md";
import dayjs from "dayjs";
import {
  TransferOrder,
  setSearchBody,
} from "../../../../../app/slices/transferOrderSlice";
import { SelectUser } from "../../../../../components/Selectors/SelectUser";
import { SelectProducts } from "../../../../../components/Selectors/SelectProducts";

const defaultSearch = {
  from_user_id: null,
  to_user_id: null,
  product_id: null,
  serial_number: "",
};

const TransferOrderTable = () => {
  const dispatch = useDispatch();

  const _TransferOrders = useSelector(
    (state) => state.transferOrder.transferOrders
  );
  const _SearchBody = useSelector((state) => state.transferOrder.searchBody);
  const _Users = useSelector((state) => state.user.usersList.data);
  const _Products = useSelector((state) => state.product.products.data);

  const [search, setSearch] = useState(defaultSearch);
  const [pageSize, setPageSize] = useState(15);
  const [currentPage, setCurrentPage] = useState(0);

  const columns = [
    {
      field: "index",
      headerName: "#",
      flex: 0.3,
    },
    {
      field: "id",
      headerName: "رقم المناقلة",
      flex: 0.7,
    },
    {
      field: "from_user_name",
      headerName: "من",
      flex: 1,
    },
    {
      field: "to_user_name",
      headerName: "الى",
      flex: 1,
    },
    {
      field: "items_count",
      headerName: "عدد المواد",
      flex: 0.7,
    },
    {
      field: "total_quantity",
      headerName: "العدد الكلي",
      flex: 0.7,
    },
    {
      field: "note",
      headerName: "الملاحظات",
      flex: 1,
    },
    {
      field: "created_by_name",
      headerName: "انشاءت بواسطة",
      flex: 1,
    },
    {
      field: "created_at",
      headerName: "تاريخ الانشاء",
      flex: 1,
      renderCell: (params) => dayjs(params.row.created_at).format("YYYY-MM-DD"),
    },
    {
      field: "operations",
      headerName: "العمليات",
      flex: 0.7,
      renderCell: (params) => (
        <Tooltip title="التفاصيل">
          <IconButton
            onClick={() => dispatch(TransferOrder.getById(params.row.id))}
          >
            <BiInfoCircle />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(TransferOrder.getAll(_SearchBody));
    }, 500);
    return () => clearTimeout(timeout);
  }, [_SearchBody, dispatch]);

  useEffect(() => {
    dispatch(
      setSearchBody({
        from_user_id: search.from_user_id ?? "",
        to_user_id: search.to_user_id ?? "",
        product_id: search.product_id ?? "",
        serial_number: search.serial_number,
        skip: currentPage * pageSize,
        take: pageSize,
      })
    );
  }, [currentPage, dispatch, pageSize, search]);

  return (
    <Card>
      <CardContent>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item xs={12} md={3}>
            <SelectUser
              label="من"
              onChange={(e, newValue) => {
                setSearch({
                  ...search,
                  from_user_id: newValue ? newValue.id : null,
                });
              }}
              value={
                _Users.filter((x) => x.id === search.from_user_id)[0] ?? null
              }
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <SelectUser
              label="الى"
              onChange={(e, newValue) => {
                setSearch({
                  ...search,
                  to_user_id: newValue ? newValue.id : null,
                });
              }}
              value={
                _Users.filter((x) => x.id === search.to_user_id)[0] ?? null
              }
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <SelectProducts
              onChange={(e, newValue) => {
                setSearch({
                  ...search,
                  product_id: newValue ? newValue.id : null,
                });
              }}
              value={
                _Products.filter((x) => x.id === search.product_id)[0] ?? null
              }
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <TextField
              size="small"
              value={search.serial_number}
              onChange={(e) =>
                setSearch({ ...search, serial_number: e.target.value })
              }
              label="الرقم التسلسلي"
              fullWidth
            />
          </Grid>
          <Grid item xs="auto" md={1}>
            <Tooltip title="الغاء الفلتر">
              <IconButton
                onClick={() => {
                  setSearch(defaultSearch);
                  setPageSize(15);
                  setCurrentPage(0);
                }}
              >
                <MdOutlineClear />
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ height: { xs: "auto", md: "63vh" }, width: "100%" }}>
              <ResponsiveDataGrid
                gridHeight={null}
                rows={
                  _TransferOrders.data?.map((x, i) => ({
                    ...x,
                    index: i + 1 + pageSize * currentPage,
                  })) ?? []
                }
                columns={columns}
                pageSize={pageSize}
                page={currentPage}
                rowCount={_TransferOrders.total}
                loading={_TransferOrders.loading}
                rowHeight={50}
                pagination
                paginationMode="server"
                selectionModel={[]}
                onPageChange={(newPage) => setCurrentPage(newPage)}
                rowsPerPageOptions={[15, 25, 50, 100]}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                components={{ LoadingOverlay: LinearProgress }}
                mobile={{
                  titleField: "from_user_name",
                  subtitleField: "to_user_name",
                  noteField: "note",
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default TransferOrderTable;
